import { UseMutationOptions } from 'react-query';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';
import MutationKeys from './keys';

export type CreateSmsInput = {
    name: string;
    content: string;
    parentFolderId?: number;
};

const useCreateSms = (mutateOptions: UseMutationOptions<unknown, Error, CreateSmsInput>) =>
    useMutation<CreateSmsInput>(MutationKeys.CREATE_SMS, CuredApiPaths.SMS, mutateOptions);

export default useCreateSms;
